/**
 * User-facing copy for the ctx-param gate (#404).
 *
 * No-access / failure messages by kind and cause. The switching wait has no words (#1561).
 */

/**
 * Maximum time (ms) the write-safety hold will wait for in-flight mutations
 * and active uploads to settle before proceeding with the context switch.
 * Never trap the user (consume worst-outcome rule). (#404 slice 1c)
 */
export const CTX_GATE_HOLD_MAX_MS = 30_000;

export const ctxGateMessages = {
  /** No-access page: 403/404 — user is not a member or the id is unknown. */
  noAccessTitle: {
    org: "You don't have access to that organization",
    network: "You don't have access to that network",
  } as Record<string, string>,

  /** No-access page: any other failure (400/422/network error/5xx). */
  failedTitle: {
    org: "Couldn't open that organization",
    network: "Couldn't open that network",
  } as Record<string, string>,

  /** Action labels on the no-access / failed page. */
  tryAgain: 'Try again',
  goHome: 'Go to my dashboard',
} as const;
